// ELEV8 Hydration theme JS — cart, variant/flavor pickers, small interactions.
(function () {
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  function addToCart(variantId, quantity, sellingPlanId, onDone) {
    var body = { items: [{ id: variantId, quantity: quantity || 1 }] };
    if (sellingPlanId) body.items[0].selling_plan = sellingPlanId;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
      return res.json();
    }).then(function (item) {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      updateCartCount(cart.item_count);
      if (onDone) onDone(null, cart);
      return cart;
    }).catch(function (e) {
      if (onDone) onDone(e);
    });
  }
  window.ELEV8 = window.ELEV8 || {};
  window.ELEV8.addToCart = addToCart;

  function formatMoneyGlobal(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function renderCartDrawer(cart) {
    var itemsEl = qs('[data-cart-drawer-items]');
    var totalEl = qs('[data-cart-drawer-total]');
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="e8-cart-drawer-empty">Your cart is empty.</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        return '<div class="e8-cart-drawer-line">' +
          '<img src="' + sizedImage(item.image, 128) + '" alt="">' +
          '<div><div class="e8-cart-drawer-line-title">' + item.product_title + '</div>' +
          '<div class="e8-cart-drawer-line-variant">' + item.variant_title + ' · Qty ' + item.quantity + '</div></div>' +
          '<div class="e8-cart-drawer-line-price">' + formatMoneyGlobal(item.final_line_price) + '</div>' +
          '</div>';
      }).join('');
    }
    if (totalEl) totalEl.textContent = formatMoneyGlobal(cart.total_price);
  }

  function openCartDrawer(cart) {
    var drawer = qs('#e8-cart-drawer');
    if (!drawer) return;
    if (cart) {
      renderCartDrawer(cart);
    } else {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer);
    }
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = qs('#e8-cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  window.ELEV8.openCartDrawer = openCartDrawer;
  window.ELEV8.closeCartDrawer = closeCartDrawer;

  qsa('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  qsa('.e8-cart-link').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  // Simple one-off "add to cart" buttons (pricing cards, quick-buy)
  qsa('[data-e8-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      var sellingPlanId = btn.getAttribute('data-selling-plan-id') || null;
      var msgEl = btn.closest('[data-e8-card]') && btn.closest('[data-e8-card]').querySelector('[data-e8-msg]');
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      addToCart(variantId, 1, sellingPlanId, function (err, cart) {
        btn.disabled = false;
        if (err) {
          btn.textContent = original;
          if (msgEl) { msgEl.textContent = err.message; msgEl.className = 'e8-pdp-message error'; }
          return;
        }
        btn.textContent = 'Added \u2713';
        if (msgEl) {
          msgEl.className = 'e8-pdp-message success';
          msgEl.textContent = 'Added to cart.';
        }
        openCartDrawer(cart);
        setTimeout(function () {
          btn.textContent = original;
        }, 2200);
      });
    });
  });

  // ---- Flavor switcher (homepage: flavor showcase + pricing grid share state) ----
  var flavorGroups = qsa('[data-flavor-switch]');
  var flavorCardGroups = qsa('[data-default-flavor]');
  if (flavorGroups.length || flavorCardGroups.length) {
    function applyFlavor(flavor) {
      qsa('[data-flavor-switch] button').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-flavor-value') === flavor ? 'true' : 'false');
      });
      qsa('[data-flavor-panel]').forEach(function (panel) {
        panel.style.display = panel.getAttribute('data-flavor-panel') === flavor ? '' : 'none';
      });
      qsa('[data-flavor-card]').forEach(function (card) {
        card.style.display = card.getAttribute('data-flavor-card') === flavor ? '' : 'none';
      });
    }
    flavorGroups.forEach(function (group) {
      qsa('button', group).forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyFlavor(btn.getAttribute('data-flavor-value'));
        });
      });
    });
    var defaultFlavor = (flavorGroups[0] && flavorGroups[0].getAttribute('data-default-flavor'))
      || (flavorCardGroups[0] && flavorCardGroups[0].getAttribute('data-default-flavor'))
      || (qs('[data-flavor-value]') && qs('[data-flavor-value]').getAttribute('data-flavor-value'));
    if (defaultFlavor) applyFlavor(defaultFlavor);
  }

  // ---- Product page: option + selling plan picker ----
  var pdpForm = qs('[data-pdp-form]');
  if (pdpForm) {
    var variants = JSON.parse(qs('[data-pdp-variants]').textContent);
    var idInput = qs('input[name="id"]', pdpForm);
    var sellingPlanInput = qs('input[name="selling_plan"]', pdpForm);
    var priceEl = qs('[data-pdp-price]');
    var compareEl = qs('[data-pdp-compare]');
    var mediaEl = qs('[data-pdp-media-img]');
    var msgEl = qs('[data-pdp-msg]');
    var submitBtn = qs('[data-pdp-submit]');
    var selected = {};

    qsa('[data-option-name]').forEach(function (group) {
      var name = group.getAttribute('data-option-name');
      var active = qs('.e8-option-pill.active', group);
      if (active) selected[name] = active.getAttribute('data-option-value');
      qsa('.e8-option-pill', group).forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.classList.contains('unavailable')) return;
          selected[name] = pill.getAttribute('data-option-value');
          qsa('.e8-option-pill', group).forEach(function (p) { p.classList.toggle('active', p === pill); });
          syncVariant();
        });
      });
    });

    var sellingPlanSelected = null;
    qsa('[data-selling-plan-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        qsa('[data-selling-plan-option]').forEach(function (o) { o.classList.remove('active'); });
        opt.classList.add('active');
        sellingPlanSelected = opt.getAttribute('data-selling-plan-id') || null;
        sellingPlanInput.value = sellingPlanSelected || '';
        syncVariant();
      });
    });

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return selected['option' + (i + 1)] === val; });
      });
    }

    function syncVariant() {
      var variant = findVariant();
      if (!variant) return;
      idInput.value = variant.id;
      var plan = sellingPlanSelected && variant.selling_plan_allocations
        ? variant.selling_plan_allocations.find(function (a) { return a.selling_plan_id == sellingPlanSelected; })
        : null;
      var price = plan ? plan.price : variant.price;
      priceEl.textContent = formatMoney(price);
      if (compareEl) {
        if (!plan && variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (mediaEl && variant.featured_image) mediaEl.src = variant.featured_image.src;
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }

    function formatMoney(cents) {
      return (window.Shopify && Shopify.currency && Shopify.currency.active ? '' : '') + '€' + (cents / 100).toFixed(2);
    }

    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitBtn.disabled = true;
      var qty = parseInt(qs('input[name="quantity"]', pdpForm).value || '1', 10);
      addToCart(idInput.value, qty, sellingPlanInput.value || null, function (err, cart) {
        submitBtn.disabled = false;
        if (err) { msgEl.textContent = err.message; msgEl.className = 'e8-pdp-message error'; return; }
        msgEl.className = 'e8-pdp-message success';
        msgEl.textContent = 'Added to cart.';
        openCartDrawer(cart);
      });
    });

    syncVariant();
  }

  // ---- Cart quantity updates ----
  qsa('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-cart-qty');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: input.value }),
      }).then(function () { window.location.reload(); });
    });
  });

  // ---- Simple newsletter / B2B / notify forms (no backend — swap for a real app/Flow later) ----
  qsa('[data-e8-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var successEl = form.parentElement.querySelector('[data-e8-form-success]');
      form.style.display = 'none';
      if (successEl) successEl.style.display = 'flex';
    });
  });

  // ---- Reveal-on-scroll ----
  var revealEls = qsa('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) entry.target.classList.add('in'); });
    }, { threshold: .15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }
})();
